<modal-panel [title]="'Passengers for Booking Number ' + bookingNo" data-testid="adx-booking-passengers-modal-panel" (close)="close()">
  <div data-testid="adx-booking-passengers-modal-content">
    @if (hasData) {
      <mat-card class="mat-elevation-z8">
        <mat-card-content>
          <mat-list>
            @for (passenger of passengers; track passenger.id) {
              <mat-list-item>
                <div style="display: flex; flex-direction: column; width: 100%;">
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <strong>{{getFullName(passenger)}}</strong>
                    @if (passenger.isPrimary) {
                      <mat-chip color="primary" style="height: 24px; font-size: 12px;">Primary</mat-chip>
                    }
                  </div>
                  <div style="font-size: 0.9em; color: #666; margin-top: 4px;">
                    @if (passenger.dateOfBirth) {
                      <span>DOB: {{passenger.dateOfBirth | date:'mediumDate'}}</span>
                    }
                    @if (passenger.adxTravelerId) {
                      <span style="margin-left: 15px;">Traveler ID: {{passenger.adxTravelerId}}</span>
                    }
                    @if (passenger.acaveId) {
                      <span style="margin-left: 15px;">ACAVE ID: {{passenger.acaveId}}</span>
                    }
                  </div>
                  @if (passenger.passengerTicketInfo) {
                    <div style="font-size: 0.9em; color: #666; margin-top: 4px;">
                      <span>Ticket #: {{passenger.passengerTicketInfo.ticketNumber || 'N/A'}}</span>
                      <span style="margin-left: 15px;">Ticket Type: {{passenger.passengerTicketInfo.ticketType || 'N/A'}}</span>
                      <span style="margin-left: 15px;">Airline: {{passenger.passengerTicketInfo.airlineCode || 'N/A'}}</span>
                      <span style="margin-left: 15px;">E-Ticket: {{passenger.passengerTicketInfo.isETicket ? 'Yes' : 'No'}}</span>
                      @if (passenger.passengerTicketInfo.isVoided) {
                        <span style="margin-left: 15px; color: #b00020;">Voided</span>
                      }
                    </div>
                  }
                  @if (passenger.passengerPriceBreakdown) {
                    <div style="font-size: 0.9em; color: #666; margin-top: 4px;">
                      <span>Base Fare: {{passenger.passengerPriceBreakdown.baseFare}} {{passenger.passengerPriceBreakdown.currency}}</span>
                      <span style="margin-left: 15px;">Taxes: {{passenger.passengerPriceBreakdown.taxes}}</span>
                      <span style="margin-left: 15px;">Total Fare: {{passenger.passengerPriceBreakdown.totalFare}}</span>
                      @if (passenger.passengerPriceBreakdown.passengerTaxes?.length) {
                        <div style="margin-top: 2px;">
                          @for (tax of passenger.passengerPriceBreakdown.passengerTaxes; track $index) {
                            <span style="margin-right: 15px;">{{tax.qualifierCode}}: {{tax.amount}} ({{tax.countryCode}})</span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </mat-list-item>
              <mat-divider></mat-divider>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    } @else {
      <p>No passenger data available for this booking.</p>
    }
  </div>
  
  <ng-container data-testid="adx-booking-passengers-modal-footer" modalPanelFooter>
    <button data-testid="adx-booking-passengers-modal-close-button" mat-raised-button color="primary" (click)="close()">
      Close
    </button>
  </ng-container>
</modal-panel>
